import React from 'react'
import { setActiveSort } from '../../store/itinerary/itinerarySlice'
import s from './ItinerarySortNav.less'
import { SORT_TYPES } from '../../store/itinerary/itinerary.constants'
import classnames from 'classnames'
import T from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'
import arrow from './light-arrow-down.svg'
import { useDispatch, useSelector } from 'react-redux'
import { selectActiveSort } from '../../store/itinerary/itinerary.selectors'
import { TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { PUB_TAG } from '../analytics/PublisherTagsService'
import TagActionButton from '../genericComponents/TagActionButton'

const tagSortMatching = {
  [SORT_TYPES.duration]: 'duree',
  [SORT_TYPES.price]: 'prix',
  [SORT_TYPES.co2]: 'emission_co2'
}

const ItinerarySortNav = () => {
  const activeSort = useSelector(selectActiveSort)
  const dispatch = useDispatch()

  return (
    <ul className={s.list}>
      {Object.keys(SORT_TYPES).map(key => {
        const isActive = activeSort === key
        return (
          <li key={key} className={classnames(s.item, isActive ? s.active : s.unactive)}>
            <TagActionButton
              type={TAG_MULTIPATH_CTA}
              tagInfo={{
                tag: PUB_TAG.PUB_ATC_MULTIPATH_TRI_RESULTAT,
                libelle_CTA: tagSortMatching[key]
              }}
              className={s.itemButton}
              onClick={() => dispatch(setActiveSort(key))}
            >
              <div className={s.itemLabel}>
                {isActive && (
                  <span className={s.icon}>
                    <SVGIcon url={arrow} />
                  </span>
                )}
                <T id={`itinerary.sort.${key}`} />
              </div>
            </TagActionButton>
          </li>
        )
      })}
    </ul>
  )
}

export default ItinerarySortNav
